/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
export const PlatformColumnFormatter = ( cellContent, row, rowIndex ) => (
  <>
    { row.isin_shopify &&
      <span>
        <img src={toAbsoluteUrl("/media/platforms/shopify.png")} alt={row.name} title="Shopify" height="38" width="38"></img>
      </span>
    }

    { row.isin_wp &&
      <span style={{ marginRight:'5px' }}>
        <img src={toAbsoluteUrl("/media/platforms/wordpress.png")} alt={row.name} title="Wordpress" height="38" width="38"></img>
      </span>
    }
    
    { row.isin_wix &&
      <span style={{ marginRight:'10px' }}>
        <img src={toAbsoluteUrl("/media/platforms/wix.png")} alt={row.name} title="Wix" height="38" width="38"></img>
      </span>
    }
    
    { row.isin_venderportal &&
      <span style={{ marginRight:'5px' }}>
        <img src={toAbsoluteUrl("/media/platforms/vendorPortal.png")} alt={row.name} title="Vendor Portal" height="38" width="38"></img>
      </span>
    }

    { row.isin_bc &&
      <span>
        <img src={toAbsoluteUrl("/media/platforms/bigcommerce.png")} alt={row.name} title="BigCommerce" height="38" width="38"></img>
      </span>
    }
  </>
);
